class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.header = document.querySelector(".section-header");
        this.headerIsAlwaysSticky = this.getAttribute("data-sticky-type") === "always" || this.getAttribute("data-sticky-type") === "reduce-logo-size";
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia("(max-width: 990px)").addEventListener("change", this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
            this.header.classList.add("shopify-section-header-sticky");
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector("predictive-search");

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.addEventListener("scroll", this.onScrollHandler, false);

        this.createObserver();
    }

    setHeaderHeight() {
        document.documentElement.style.setProperty("--header-height", `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
        this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.removeEventListener("scroll", this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add("scrolled-past-header");
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add("scrolled-past-header");
            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove("scrolled-past-header");
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky");
        this.closeMenuDisclosure();
        this.closeSearchModal();
    }

    reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add("shopify-section-header-sticky", "animate");
        this.header.classList.remove("shopify-section-header-hidden");
    }

    reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove("shopify-section-header-hidden", "shopify-section-header-sticky", "animate");
    }

    closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll("header-menu");
        this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
  this.searchModal = this.searchModal || this.header.querySelector("details-modal");

  if (this.searchModal && typeof this.searchModal.close === "function") {
    this.searchModal.close(false);
  }
}

}

customElements.define("sticky-header", StickyHeader);

// Hover Mega menu opening function
function bindMegaMenuHover(item) {
    let timeout;

    item.addEventListener("mouseenter", () => {
        clearTimeout(timeout);
        item.setAttribute("open", true);
    });

    item.addEventListener("mouseleave", () => {
        timeout = setTimeout(() => {
            item.removeAttribute("open");
        }, 200);
    });
}

document.querySelectorAll("details.mega-menu").forEach((menu) => {
  bindMegaMenuHover(menu);

  const tabs = menu.querySelectorAll(".mega-menu__tab");
  const panels = menu.querySelectorAll(".mega-menu__tab-panel");
  const allImages = menu.querySelectorAll(".mega-menu__image");

  // Child tabs logic (hover/focus/click)
  tabs.forEach((tab) => {
    const targetPanelId = tab.getAttribute("data-tab");
    const targetPanel = menu.querySelector(`.mega-menu__tab-panel[data-tab-id="${targetPanelId}"]`);

    const activateTab = () => {
      tabs.forEach((t) => t.classList.remove("active"));
      panels.forEach((p) => p.classList.remove("active"));
      tab.classList.add("active");
      if (targetPanel) targetPanel.classList.add("active");

      // Show child preview image
      const imageId = `image-${targetPanelId.replace("coach", "child-")}`;
      const imageToShow = menu.querySelector(`#${imageId}`);
      allImages.forEach((img) => img.classList.remove("active"));
      if (imageToShow) imageToShow.classList.add("active");
    };

    tab.addEventListener("mouseenter", activateTab);
    tab.addEventListener("focus", activateTab);

    tab.addEventListener("click", () => {
      const url = tab.getAttribute("data-url");
      if (url) window.location.href = url;
    });
  });

  // Grandchild (nested) items logic
  const childItems = menu.querySelectorAll(".mega-menu__nested-item");
  childItems.forEach((item) => {
    const imageId = `image-${item.dataset.image}`;
    const targetImage = menu.querySelector(`#${imageId}`);

    const activateImage = () => {
      allImages.forEach((img) => img.classList.remove("active"));
      if (targetImage) {
        targetImage.classList.add("active");
      } else {
        console.warn("No image found for:", imageId);
      }
    };

    item.addEventListener("mouseenter", activateImage);
    item.addEventListener("focus", activateImage);

    item.addEventListener("click", () => {
      const url = item.dataset.url;
      if (url) window.location.href = url;
    });
  });
});



// Toast function
let toastTimeout;
function showToast(t, e = "added", i = "/pages/wishlist") {
    let l = document.getElementById("wishlist-toast"),
        s = l.querySelector(".toast-message");
    l &&
        s &&
        ("added" === e ? (s.innerHTML = `The <strong>${t}</strong> has been added to <a href="${i}" class="wishlist-link">your Wishlist</a>.`) : (s.textContent = `The "${t}" has been removed from your Wishlist.`),
        (l.style.display = "flex"),
        l.classList.remove("animate"),
        l.offsetWidth,
        l.classList.add("animate"),
        toastTimeout && clearTimeout(toastTimeout),
        (toastTimeout = setTimeout(() => {
            hideToast();
        }, 3e3)));
}
function hideToast() {
    let t = document.getElementById("wishlist-toast");
    t && ((t.style.display = "none"), t.classList.remove("animate"));
}
function toggleWishlist(t) {
  let e = {
    productTitle: t.getAttribute("data-title"),
    productImg: t.getAttribute("data-img"),
    productPrice: t.getAttribute("data-price"),
    productUrl: t.getAttribute("data-url")
  };

  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  let alreadyExists = wishlist.some(item => item.productTitle === e.productTitle);

  if (alreadyExists) {
    wishlist = wishlist.filter(item => item.productTitle !== e.productTitle);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));

    showToast(e.productTitle, "removed");

    t.innerHTML = `
      <svg class="heart-outline" width="25px" height="25px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <rect x="0" fill="none" width="24" height="24"/>
        <g>
          <path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/>
        </g>
      </svg>
    `;

    // Remove product element
    let productBlock = t.closest(".wishlist-product__list");
    if (productBlock) productBlock.remove();

  } else {
    wishlist.push(e);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    showToast(e.productTitle, "added", "/pages/wishlist");

    t.innerHTML = `
      <svg class="heart-filled" width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
      </svg>
    `;
  }

  // Update empty state message
  const updatedWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const container = document.querySelector(".js-wishlistBlock");
  if (container && updatedWishlist.length === 0) {
    container.innerHTML = '<p class="empty-wishlist-message">Your wishlist is empty.</p>';
  }
}

function removeFromWishlist(t) {
    let e = JSON.parse(localStorage.getItem("wishlist")) || [];
    (e = e.filter((e) => e.productTitle !== t)), localStorage.setItem("wishlist", JSON.stringify(e)), displayWishlist(pdpData);
}
function displayWishlist() {
    let t = JSON.parse(localStorage.getItem("wishlist")) || [];
    if (0 === t.length) return;
    let e = t
            .map(
                (t) => `
<div class="wishlist-product__list">
  <div class="c-product">
    <a href="${t.productUrl}">
      <img src="${t.productImg}" alt="${t.productTitle}">
    </a>
    <h3 class="c-product__title card__heading h5">
      <a class="full-unstyled-link" href="${t.productUrl}">${t.productTitle}</a>
    </h3>
    

    <button 
      class="wishlist_button" 
      data-title="${t.productTitle}" 
      data-img="${t.productImg}" 
      data-price="${t.productPrice}" 
      data-url="${t.productUrl}" 
      onclick="toggleWishlist(this)"
      aria-label="Remove from Wishlist"
    >
      <svg class="heart-filled" width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
      </svg>
    </button>
  </div>
</div>
    `
            )
            .join(""),
        i = document.querySelector(".js-wishlistBlock");
    if (i) {   i.innerHTML = e; }
}
document.addEventListener("DOMContentLoaded", function () {
    let t = JSON.parse(localStorage.getItem("wishlist")) || [],
        e = document.querySelectorAll(".wishlist_button");
    e.forEach((e) => {
        let i = e.getAttribute("data-title"),
            l = t.some((t) => t.productTitle === i);
        e.innerHTML = l
            ? `<svg class="heart-filled" width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
               </svg>`
            : `<svg class="heart-outline" width="25px" height="25px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0" fill="none" width="24" height="24"/>
                  <g>
                    <path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/>
                  </g>
               </svg>`;
    }),
        displayWishlist();
}),
   document.querySelectorAll(".search__input").forEach((t) => {
        let e = t.getAttribute("placeholder"),
            i = t.getAttribute("data-placeholder");
        t.addEventListener("focus", () => t.setAttribute("placeholder", i)), t.addEventListener("blur", () => t.setAttribute("placeholder", e));
    }),
    
    // footer script
    document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 767) {
      document.querySelectorAll(".accordion-toggle").forEach(function (toggle) {
        toggle.addEventListener("click", function () {
          const content = toggle.nextElementSibling;
          const isOpen = content.classList.contains("active");

          // Close all
          document.querySelectorAll(".accordion-content").forEach(c => c.classList.remove("active"));
          document.querySelectorAll(".accordion-toggle").forEach(t => t.classList.remove("active"));

          // Toggle current
          if (!isOpen) {
            content.classList.add("active");
            toggle.classList.add("active");
          }
        });
      });
    }
  });

// Pause/Play homepage banner videos when not in viewport
document.addEventListener("DOMContentLoaded", function () {
  const banner = document.querySelector(".banner-container-983adf");
  if (!banner) return; // Exit if banner not found

  const videos = banner.querySelectorAll("video");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Play when banner visible
          videos.forEach(v => { if (v.paused) v.play().catch(() => {}); });
        } else {
          // Pause when banner hidden
          videos.forEach(v => v.pause());
        }
      });
    },
    { threshold: 0.2 } // play/pause when 20% of banner is visible
  );

  observer.observe(banner);
});
